import { useEffect } from "react";
import Lenis from "lenis";
import { Nav } from "../components/sections/Nav";
import { Banner } from "../components/sections/Banner";
import { Pillars } from "../components/sections/Pillars";
import { Work } from "../components/sections/Work";
import { AboutLine } from "../components/sections/AboutLine";
import { Inquiry } from "../components/sections/Inquiry";
import { Footer } from "../components/sections/Footer";

export default function Landing() {
  useEffect(() => {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    window.__lenis = lenis;
    let id;
    const raf = (time) => {
      lenis.raf(time);
      id = requestAnimationFrame(raf);
    };
    id = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(id);
      lenis.destroy();
      delete window.__lenis;
    };
  }, []);

  return (
    <div className="min-w-0 overflow-x-hidden">
      <Nav />
      <main>
        <Banner />
        <Pillars />
        <Work />
        <AboutLine />
        <Inquiry />
      </main>
      <Footer />
    </div>
  );
}
